export const NEW_CANONICAL_TOPIC_DROP_ZONE_ID = "new-canonical-topic"
